<template>
  <div class="q-pa-md q-gutter-sm">
    <q-btn
      label="Filtros"
      no-caps
      icon="filter_alt"
      color="primary"
      @click="abrirModal = true"
    />

    <q-dialog
      v-model="abrirModal"
      :persistent="persistent"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card style="width: 900px; max-width: 90vw">
        <div class="bg-brand-1 text-white">
          <q-card-section>
            <div class="text-h6">Filtros do Relatório PT</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            Selecione os filtros desejados e clique em 'Filtrar' para carregar
            os dados.
          </q-card-section>
        </div>

        <q-card-section class="filtros-section">
          <div class="row q-col-gutter-md">
            <div class="col-12 col-md-6 campo-filtro-top">
              <div class="label-filtro">Unidade Emissão *</div>
              <q-select
                dense
                outlined
                v-model="filtros.unidade"
                option-label="label"
                option-value="id"
                :options="optionsUnidade"
                label="Selecione a unidade"
                @update:model-value="onUnidadeChange"
              />
            </div>

            <div class="col-12 col-md-6 campo-filtro-top">
              <div class="label-filtro">ID Modelo</div>
              <q-select
                dense
                outlined
                v-model="filtros.modelo"
                option-label="modeloNome"
                option-value="modeloId"
                :options="optionsModelo"
                label="Selecione o modelo"
                clearable
              />
            </div>

            <div class="col-12 col-md-6 campo-filtro-top">
              <div class="label-filtro">Data Inicial *</div>
              <q-input
                dense
                outlined
                placeholder="DD/MM/AAAA"
                v-model="filtros.dataInicial"
                mask="##/##/####"
                :rules="[(val) => validarDataEmissao(val) || 'Data Inválida']"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        :options="optionsFn"
                        mask="DD/MM/YYYY"
                        v-model="filtros.dataInicial"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="col-12 col-md-6 campo-filtro-top">
              <div class="label-filtro">Data Final *</div>
              <q-input
                dense
                outlined
                placeholder="DD/MM/AAAA"
                v-model="filtros.dataFinal"
                mask="##/##/####"
                :rules="[(val) => validarDataEmissao(val) || 'Data Inválida']"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        :options="optionsFn"
                        mask="DD/MM/YYYY"
                        v-model="filtros.dataFinal"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>

            <div class="col-12 col-md-6 campo-filtro campo-filtro-bottom">
              <div class="label-filtro">Número PT</div>
              <q-input
                dense
                outlined
                v-model="filtros.ptId"
                type="number"
                placeholder="Digite o número da PT"
              />
            </div>

            <div class="col-12 col-md-6 campo-filtro campo-filtro-bottom">
              <div class="label-filtro">Local</div>
              <q-input
                dense
                outlined
                v-model="filtros.local"
                placeholder="Digite o local"
              />
            </div>

            <div class="col-12 col-md-6 campo-filtro">
              <div class="label-filtro">Status</div>
              <q-select
                dense
                outlined
                v-model="filtros.status"
                multiple
                :options="statusOptions"
                option-label="label"
                option-value="value"
                :display-value="getDisplayValue()"
              >
                <q-tooltip
                  v-if="filtros.status.length > 0"
                  anchor="top middle"
                  self="bottom middle"
                  :offset="[0, 8]"
                >
                  <div style="max-width: 300px">
                    <strong
                      >Status selecionados ({{
                        filtros.status.length
                      }}):</strong
                    ><br />
                    {{ filtros.status.map((s) => s.label).join(", ") }}
                  </div>
                </q-tooltip>
              </q-select>
            </div>

            <div class="col-12 col-md-6 campo-filtro">
              <div class="label-filtro">Emissor (Matrícula/Email)</div>
              <q-input
                dense
                outlined
                v-model="filtros.emissor"
                placeholder="Digite matrícula ou email do emissor"
              />
            </div>

            <div class="col-12 col-md-6 campo-filtro">
              <div class="label-filtro">Participante (Matrícula/Email)</div>
              <q-input
                dense
                outlined
                v-model="filtros.participante"
                placeholder="Digite matrícula ou email do participante"
              />
            </div>

            <div class="col-12 col-md-6 campo-filtro">
              <div class="label-filtro">Atividade</div>
              <q-input
                dense
                outlined
                v-model="filtros.atividade"
                placeholder="Digite o nome da atividade"
              />
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal q-pa-md">
          <q-btn
            label="Limpar"
            no-caps
            flat
            color="primary"
            @click="limparFiltros"
          />
          <q-btn
            label="Filtrar"
            :loading="loading"
            no-caps
            icon="filter_alt"
            color="primary"
            @click="aplicarFiltros"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { validarDataEmissao } from "../../../helpers/dateValidation";

export default {
  props: ["loadingValue"],
  setup(props, { emit }) {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const loading = ref(false);
    const abrirModal = ref(
      route.params.id != "" &&
        route.params.id != undefined &&
        route.params.id != "carregado"
        ? false
        : true
    );
    const persistent = ref(false);
    const id = route.params.id;

    const filtros = ref({
      unidade: {
        id: store.state.org.unidadeData.id,
        label: store.state.org.unidadeData.nome,
      },
      dataInicial: "",
      dataFinal: "",
      modelo: "",
      ptId: "",
      emissor: "",
      participante: "",
      local: "",
      status: [],
      atividade: "",
    });

    const optionsUnidade = ref([]);
    const optionsModelo = ref([]);

    const statusOptions = [
      { label: "Em aberto", value: "aberto" },
      { label: "Em assinatura", value: "aguardando_assinaturas" },
      { label: "Iniciado", value: "iniciado" },
      { label: "Encerrado", value: "encerrado" },
      { label: "Cancelado", value: "cancelado" },
      { label: "Finalizado", value: "finalizado" },
    ];

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    const optionsFn = (date) => {
      const hoje = new Date();
      const ontem = new Date(hoje.getTime());
      ontem.setDate(hoje.getDate());

      const dd = ontem.getDate();
      const mm = ontem.getMonth() + 1;
      const yyyy = ontem.getFullYear();

      const dataFormatada = `${yyyy}/${mm.toString().padStart(2, "0")}/${dd
        .toString()
        .padStart(2, "0")}`;

      return date <= dataFormatada;
    };

    const aplicarFiltros = async () => {
      if (!filtros.value.unidade || !filtros.value.unidade.id) {
        quasar.notify({
          message: "Selecione a unidade",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return;
      }

      if (!filtros.value.dataInicial || !filtros.value.dataFinal) {
        const dataFinal = new Date();
        const dataInicial = new Date();
        dataInicial.setDate(dataInicial.getDate() - 15);

        filtros.value.dataInicial = dataInicial.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        filtros.value.dataFinal = dataFinal.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      }

      loading.value = true;

      const dataInicialFormatada = filtros.value.dataInicial
        .split("/")
        .reverse()
        .join("-");
      const dataFinalFormatada = filtros.value.dataFinal
        .split("/")
        .reverse()
        .join("-");

      const filtrosFormatados = {
        unidadeId: filtros.value.unidade.id,
        dataInicial: dataInicialFormatada,
        dataFinal: dataFinalFormatada,
        modeloId: filtros.value.modelo || undefined,
        ptId: filtros.value.ptId || undefined,
        emissor: filtros.value.emissor || undefined,
        participante: filtros.value.participante || undefined,
        local: filtros.value.local || undefined,
        status:
          filtros.value.status.length > 0
            ? filtros.value.status
                .map((s) => (typeof s === "object" ? s.value : s))
                .join(",")
            : undefined,
        atividade: filtros.value.atividade || undefined,
      };

      emit("filtrar", filtrosFormatados, filtros.value);
    };

    const limparFiltros = () => {
      filtros.value = {
        unidade: {
          id: store.state.org.unidadeData.id,
          label: store.state.org.unidadeData.nome,
        },
        dataInicial: "",
        dataFinal: "",
        modelo: "",
        ptId: "",
        emissor: "",
        participante: "",
        local: "",
        status: [],
        atividade: "",
      };
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        let array = response.listaUnidades;
        array.forEach((unidade) => {
          optionsUnidade.value.push({
            label: unidade.nome,
            id: unidade.id,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    const listarModelos = async (unidadeId) => {
      try {
        const response = await store.dispatch("pdt/listarModelos", {
          unidadeId: unidadeId,
        });
        optionsModelo.value = response.data.resultado.dados || [];
      } catch (error) {
        console.log(error);
        optionsModelo.value = [];
      }
    };

    const onUnidadeChange = (unidade) => {
      filtros.value.modelo = null;
      optionsModelo.value = [];
      if (unidade && unidade.id) {
        listarModelos(unidade.id);
      }
    };

    const getDisplayValue = () => {
      if (filtros.value.status.length === 0) {
        return "Selecione os status";
      }

      const labels = filtros.value.status.map((s) => s.label);
      const maxLength = 35;

      if (labels.length === 1) {
        return labels[0];
      }

      if (labels.length === 2) {
        const text = labels.join(", ");
        return text.length > maxLength ? `${labels[0]}, ...` : text;
      }

      return `${labels[0]}, ${labels[1]} e mais ${labels.length - 2}`;
    };

    watch(
      () => props.loadingValue,
      () => {
        loading.value = props.loadingValue;
        if (loading.value == false) {
          setTimeout(() => {
            abrirModal.value = false;
            persistent.value = false;
          }, 1000);
        }
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        filtros.value.unidade = {
          id: store.state.org.unidadeData.id,
          label: store.state.org.unidadeData.nome,
        };
      }
    );

    watch(
      () => abrirModal.value,
      (novoValor) => {
        if (novoValor && filtros.value.unidade && filtros.value.unidade.id) {
          listarModelos(filtros.value.unidade.id);
        }
      }
    );

    const verificarPersistencia = async () => {
      if (id) {
        persistent.value = false;
      }
    };

    const inicializar = async () => {
      if (filtros.value.unidade && filtros.value.unidade.id) {
        await listarModelos(filtros.value.unidade.id);
      }
    };

    onMounted(verificarPersistencia);
    onMounted(listarUnidades);
    onMounted(inicializar);

    return {
      abrirModal,
      filtros,
      loading,
      persistent,
      optionsUnidade,
      optionsModelo,
      statusOptions,
      myLocale,
      optionsFn,
      aplicarFiltros,
      limparFiltros,
      validarDataEmissao,
      getDisplayValue,
      onUnidadeChange,
    };
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.filtros-section {
  padding: 16px !important;
}

.campo-filtro-top {
  margin-bottom: 18px !important;
  padding-bottom: 0 !important;
}

.campo-filtro {
  margin-bottom: 24px !important;
  padding-bottom: 0 !important;
}

.campo-filtro-bottom {
  margin-top: -15px !important;
}

.label-filtro {
  color: #5d6163;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px !important;
  line-height: 1.2;
  display: block;
}

:deep(.q-field--dense .q-field__control) {
  min-height: 40px;
  height: 40px;
}

:deep(.q-field--dense .q-field__native) {
  min-height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
}

:deep(.q-field--dense.q-select .q-field__control) {
  padding-top: 0;
  padding-bottom: 0;
}

.row.q-col-gutter-md {
  margin-left: -8px !important;
  margin-right: -8px !important;
  margin-top: 0 !important;
}

.row.q-col-gutter-md > div {
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

:deep(.q-field--dense .q-chip) {
  margin: 2px;
}

:deep(.q-field--outlined .q-field__control) {
  border-radius: 4px;
}

:deep(.q-field--outlined .q-field__control:before) {
  border: 1px solid rgba(0, 0, 0, 0.24);
}

:deep(.q-field) {
  margin-bottom: 0 !important;
}
</style>
